import axiosInstance from './axios-instance';

// CREATE
export const createNote = async (payload: any) => {
  try {
    const res = await axiosInstance.post(`/notebook/create`, payload);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// DELETE
export const deleteNote = async (id: any) => {
  try {
    const res = await axiosInstance.delete(`/notebook/delete/${id}`);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// UPDATE
export const updateNote = async (payload: any) => {
  try {
    const res = await axiosInstance.patch(`/notebook/update`, payload);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// READ
export const getNotes = async (payload: any) => {
  try {
    const res = await axiosInstance.post(`/notebook/read`, payload);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
